module.exports = __webpack_public_path__ + "img/b38.c080eec4.jpeg";